// extracted by mini-css-extract-plugin
export default {"mainItem":"PlayerSettingsSubOptions_mainItem__0Cwlz","subOptions":"PlayerSettingsSubOptions_subOptions__oZlAS"};